import { FormikErrors, FormikTouched } from 'formik';

export const getHelperText = (
  errors: FormikErrors<any> | undefined,
  touched: FormikTouched<any> | undefined,
  field: string,
) => {
  const error = errors?.[field];
  const isTouched = !!touched?.[field];
  if (isTouched && typeof error === 'string') return error;
  return '';
};
